export const MODULE_ID = 'setup';
export const HCP_PROFILE_FORM = `${MODULE_ID}.hcpProfileForm`;
export const PATIENT_PROFILE_FORM = `${MODULE_ID}.patientProfileForm`;
export const CG_PROFILE_FORM = `${MODULE_ID}.cgProfileForm`;
